import { Injectable } from '@angular/core';

@Injectable()
export class ScriptLoaderService {
  private loadPromise: Promise<void>;
  private scriptUrl;
  private validAccountHostMatcher: RegExp = /^[a-zA-Z0-9_-]+\.nanorep\.(com?|info)$/i;
  private validFakePartMatcher: RegExp = /^\/~[a-zA-Z0-9_-]+$/;

  public loadScript(accountHost: string): Promise<void> {
    this.createNanorepScriptUrl(accountHost);
    if (!this.loadPromise) {
      this.loadPromise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = this.scriptUrl;
        script.onload = () => resolve();
        script.onerror = () => reject();

        document.head.appendChild(script);
      });
    }
    return this.loadPromise;
  }

  private createNanorepScriptUrl(accountHost: string) {
    if (!accountHost || !this.isAccountHostValid(accountHost)) {
      throw new Error('Invalid nanorepHost');
    }
    this.scriptUrl = `https://${accountHost}/web/include.js?sdk=query-field,quick-answer&api=search`;
  }

  private isAccountHostValid(accountHost: string): boolean {
    const accountHostWithProtocol = (accountHost.indexOf('://') === -1)
      ? `https://${accountHost}`
      : accountHost;
    const accountUrl = new URL(accountHostWithProtocol);

    if (this.hasPath(accountUrl) && !this.validFakePartMatcher.test(accountUrl.pathname)) {
      return false;
    }

    return this.validAccountHostMatcher.test(accountUrl.host);
  }

  private hasPath(url: URL): boolean {
    return url.pathname.length > 0 && url.pathname !== '/';
  }
}
